export const SizeCompare_DE = [
  ['Grösse des Gletschers im Vergleich'],
  ['Schweiz', '41’285 km²'],
  ['Thwaites-Gletscher', '192’000 km²'],
  [<>Gross&shy;britannien</>, '243’610 km²'],
]

export const SizeCompare_FR = [
  ['Comparaison de la taille du glacier'],
  ['Suisse', '41’285 km²'],
  ['Glacier Thwaites', '192’000 km²'],
  [<>Grande-Bretagne</>, '243’610 km²'],
]
